<template>
    <span>
        <v-speed-dial
            v-model="fab"
            fixed
            direction="top"
            :transition="transition"
            style="bottom: 37px; right: 30px;"
        >
            <template v-slot:activator>
                <v-btn
                    v-model="fab"
                    color="teal lighten-1"
                    dark
                    fab
                    @click="estadoOferta(); $v.oferta.$reset()"
                    :loading="loadingNuevaOferta" 
                >
                    <v-icon>mdi-plus</v-icon>
                </v-btn>
            </template>
        </v-speed-dial>
        <template>
            <div>
                <v-row
                    justify="center"
                >
                    <!-- Dialogo 1 -->
                    <!-- Dialogo crear oferta -->
                    <v-dialog
                        v-model="dialog"
                        fullscreen
                        hide-overlay
                        transition="dialog-bottom-transition"
                        scrollable
                        persistent
                    >
                        <v-card tile>
                            <v-toolbar
                                flat
                                dark
                                color="primary"
                            >
                                <v-btn
                                    icon
                                    dark
                                    @click="dialogSalir = true"
                                >
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                                <v-toolbar-title>Cabecera Oferta</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-toolbar-items>
                                    <v-btn
                                        dark
                                        text
                                        @click="dialogValoresDefecto = true;"
                                        icon
                                    >
                                        <v-icon>mdi-delete-outline</v-icon>
                                    </v-btn>
                                </v-toolbar-items>
                                <v-toolbar-items @mouseover="$v.oferta.proveedor.$touch(); animacionBoton();">
                                    <v-btn
                                        dark
                                        text
                                        @click="ofertaFinalizada = false; guardarTodo();"
                                        :disabled="$v.oferta.$invalid || lineas.lineas.length < 1"
                                    > <!-- disabled: los 2 tienen que ser false para que disabled sea false -->
                                        Guardar
                                    </v-btn>
                                    <v-btn
                                        dark
                                        text
                                        @click="ofertaFinalizada = true; guardarTodo();"
                                        :disabled="$v.oferta.$invalid || lineas.lineas.length < 1"
                                    > <!-- disabled: los 2 tienen que ser false para que disabled sea false -->
                                        Enviar
                                    </v-btn>
                                </v-toolbar-items>
                            </v-toolbar>
                            
                            <v-card-text class="pa-5">
                                <v-card outlined>
                                    <v-card-subtitle class="pb-0">Crear nueva oferta</v-card-subtitle>
                                    <v-card-text>
                                        <span>
                                            <v-row>
                                                <v-col cols="12" md="6">
                                                    <v-select
                                                        v-model="oferta.empresa"
                                                        @input="$v.oferta.empresa.$touch()"
                                                        @blur="$v.oferta.empresa.$touch()"
                                                        :error-messages="errorEmpresa"
                                                        :items="empresas"
                                                        @change="cambioProveedor()"
                                                        item-text="empresa.Empresa"
                                                        prepend-icon="mdi-arrow-down-drop-circle-outline"
                                                        label="Oferta para la empresa"
                                                        :disabled="bloquearCabecera"
                                                    ></v-select>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                    <v-select
                                                        v-model="oferta.almacen"
                                                        @input="$v.oferta.almacen.$touch()"
                                                        @blur="$v.oferta.almacen.$touch()"
                                                        :error-messages="errorAlmacen"
                                                        prepend-icon="mdi-arrow-down-drop-circle-outline"
                                                        :items="empresas.filter(item => item.empresa.Empresa === this.oferta.empresa)"
                                                        item-text="Descripcion"
                                                        label="Almacén destino"
                                                        return-object
                                                        :disabled="bloquearCabecera"
                                                    ></v-select>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" md="6">
                                                    <v-text-field
                                                        v-model="oferta.fechaOferta"
                                                        label="Fecha Oferta:"
                                                        prepend-icon="mdi-calendar"
                                                        disabled
                                                    >
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                    <v-dialog
                                                    ref="dialogFechaLista"
                                                    v-model="calendario.fechaLista.mostrar"
                                                    :return-value.sync="calendario.fechaLista.date"
                                                    persistent
                                                    width="290px"
                                                    >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field
                                                                v-model="calendario.fechaLista.fecha"
                                                                @click:clear="calendario.fechaLista.fecha = '';calendario.fechaLista.date = ''"
                                                                label="Fecha Lista"
                                                                prepend-icon="mdi-calendar"
                                                                readonly
                                                                v-bind="attrs"
                                                                v-on="on"
                                                            ></v-text-field>
                                                        </template>
                                                        <v-date-picker
                                                        v-model="calendario.fechaLista.date"
                                                        scrollable
                                                        >
                                                        <v-spacer></v-spacer>
                                                        <v-btn
                                                            text
                                                            @click="calendario.fechaLista.mostrar = false"
                                                        >
                                                            Cancelar
                                                        </v-btn>
                                                        <v-btn
                                                            text
                                                            color="green darken-1"
                                                            @click="$refs.dialogFechaLista.save(calendario.fechaLista.date)"
                                                        >
                                                            Aceptar
                                                        </v-btn>
                                                        </v-date-picker>
                                                    </v-dialog>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" md="6">
                                                    <v-autocomplete 
                                                    prepend-icon="mdi-file-search-outline"
                                                    :loading="loadingProveedores" 
                                                    v-model="oferta.proveedor"
                                                    :items="proveedores"
                                                    :search-input.sync="buscarProveedor"
                                                    @input="$v.oferta.proveedor.$touch()"
                                                    @blur="$v.oferta.proveedor.$touch()"
                                                    :error-messages="errorProveedor"
                                                    @keyup="debounceSearch(() => buscarProveedores()); loadingProveedores = true"
                                                    chips
                                                    color="blue-grey lighten-2" 
                                                    label="Proveedor"
                                                    hint="* Campo requerido"
                                                    persistent-hint
                                                    return-object
                                                    :filter="filterObject"
                                                    :disabled="bloquearCabecera || $v.oferta.empresa.$invalid || $v.oferta.almacen.$invalid"
                                                >
                                                    {{buscarProveedor}}
                                                    <template v-if="loadingProveedores" slot="no-data"><p class="ma-2 ml-4">Buscando...</p></template>
                                                    <template v-else-if="buscarProveedor" slot="no-data"><p class="ma-2 ml-4">No se han encontrado coincidencias con el texto introducido.</p></template>
                                                    <template v-else slot="no-data"><p class="ma-2 ml-4">Empieza a escribir para buscar.</p></template>
                                                    <template v-slot:selection="data">
                                                        <v-chip
                                                            v-bind="data.attrs"
                                                            :input-value="data.selected"
                                                            close
                                                            @click:close="oferta.proveedor = undefined"
                                                        >
                                                            {{ data.item.CodigoProveedor }} - {{ data.item.Nombre }}
                                                        </v-chip>
                                                    </template>
                                                    <template v-slot:item="data">
                                                        <template>
                                                            <v-list-item-content>
                                                                <v-list-item-title>{{ data.item.CodigoProveedor }} - {{ data.item.Nombre }}</v-list-item-title>
                                                            </v-list-item-content>
                                                        </template>
                                                    </template>
                                                </v-autocomplete>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                    <v-select
                                                        v-model="oferta.precio"
                                                        prepend-icon="mdi-arrow-down-drop-circle-outline"
                                                        :items="['Si', 'No']"
                                                        label="Precio Abierto"
                                                    ></v-select>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" md="6">
                                                    <v-dialog
                                                    ref="dialogFechaLimite"
                                                    v-model="calendario.fechaLimite.mostrar"
                                                    :return-value.sync="calendario.fechaLimite.date"
                                                    persistent
                                                    width="290px"
                                                    >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field
                                                                v-model="calendario.fechaLimite.fecha"
                                                                clearable
                                                                @click:clear="calendario.fechaLimite.fecha = '';calendario.fechaLimite.date = ''"
                                                                label="Fecha Límite Fijación Precios"
                                                                prepend-icon="mdi-calendar"
                                                                readonly
                                                                v-bind="attrs"
                                                                v-on="on"
                                                            ></v-text-field>
                                                        </template>
                                                        <v-date-picker
                                                        v-model="calendario.fechaLimite.date"
                                                        scrollable
                                                        :min=hoy
                                                        >
                                                        <v-spacer></v-spacer>
                                                        <v-btn
                                                            text
                                                            @click="calendario.fechaLimite.mostrar = false"
                                                        >
                                                            Cancelar
                                                        </v-btn>
                                                        <v-btn
                                                            text
                                                            color="green darken-1"
                                                            @click="$refs.dialogFechaLimite.save(calendario.fechaLimite.date)"
                                                        >
                                                            Aceptar
                                                        </v-btn>
                                                        </v-date-picker>
                                                    </v-dialog>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                    <v-select
                                                    v-model="oferta.pedido"
                                                        :items="['Si', 'No']"
                                                        label="Pedido Directo"
                                                        prepend-icon="mdi-arrow-down-drop-circle-outline"
                                                    ></v-select>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-text-field
                                                        v-model="oferta.observacion"
                                                        label="Observación Oferta"
                                                        maxlength="50"
                                                        counter="50"
                                                        prepend-icon="mdi-file-search-outline"
                                                        clearable
                                                        single-line
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-text-field
                                                        v-model="oferta.atencion"
                                                        label="A la atención de"
                                                        maxlength="30"
                                                        counter="30"
                                                        prepend-icon="mdi-file-search-outline"
                                                        clearable
                                                        single-line
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-select
                                                        v-model="oferta.transporte"
                                                        :items="['Externo', 'Propio', 'Proveedor']"
                                                        prepend-icon="mdi-arrow-down-drop-circle-outline"
                                                        label="Transporte"
                                                    ></v-select>
                                                </v-col>
                                            </v-row>
                                        </span>
                                    </v-card-text>
                                </v-card>
                                <!-- <v-divider></v-divider> -->
                                <v-card class="mt-5">
                                    <v-card-title>
                                        <span class="text-h5">Líneas</span>
                                        <v-spacer></v-spacer>
                                        <div @mouseover="$v.oferta.proveedor.$touch()">
                                            <v-btn color="primary" class="mt-5" @click="borrarNuevaLinea(); dialogDatosLinea = true; editando = ''; $v.nuevaLinea.$reset();" outlined :disabled="$v.oferta.$invalid" :class="{'shake' : animated}">
                                                Añadir Linea
                                            </v-btn>
                                        </div>
                                    </v-card-title>
                                    <v-card-text>
                                        <template>
                                                <v-data-table
                                                    :headers="lineas.headers"
                                                    :items="lineas.lineas"
                                                    :items-per-page="-1"
                                                    hide-default-footer
                                                    :loading=lineas.loading
                                                    :sort-by.sync="lineas.sortBy"
                                                    loading-text="Cargando..."
                                                    class="elevation-1"
                                                >
                                                <!-- XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX -->
                                                <template v-slot:item.Peso="{ item }">
                                                    {{ redondear(item.Peso,4) }}
                                                </template>
                                                <template v-slot:item.Precio="{ item }">
                                                    {{ redondear(item.Precio,2) }}
                                                </template>
                                                <template v-slot:item.Porcen_Exito_Oferta="{ item }">
                                                    {{ item.Porcen_Exito_Oferta + '%'}}
                                                </template>
                                                <template v-slot:item.acciones="{ item }">
                                                    <v-btn
                                                        icon
                                                        small
                                                        @click="editarLinea(item); $v.oferta.$reset()"
                                                    >
                                                        <v-icon dark>
                                                            mdi-pencil
                                                        </v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        icon
                                                        small
                                                        @click="borrarLinea(item)"
                                                    >
                                                        <v-icon dark>
                                                            mdi-delete
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                </v-data-table>
                                        </template>
                                    </v-card-text>
                                </v-card>
                            </v-card-text>

                            <div style="flex: 1 1 auto;"></div>
                        </v-card>
                        
                    </v-dialog>
                    <!-- FIN Dialogo 1 -->

                    <!-- Dialogo 2 -->
                    <!-- Dialogo crear linea -->
                    <v-dialog
                        v-model="dialogDatosLinea"
                        persistent
                    >
                        <v-card>
                            <v-card-title  v-if="!editando">
                                Nueva línea
                            </v-card-title>
                            <v-card-title  v-else>
                                Editar línea
                            </v-card-title>
                            <v-card-text>
                                <span>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-autocomplete
                                                :loading="loadingMateriales" 
                                                v-model="nuevaLinea.material"
                                                :items="materiales"
                                                :search-input.sync="buscarMaterial"
                                                @keyup="debounceSearch(() => buscarMateriales()); loadingMateriales = true;"
                                                chips
                                                color="blue-grey lighten-2" 
                                                label="Material"
                                                return-object
                                                :filter="filterObject"
                                                :error-messages="errorMaterial"
                                                @input="$v.nuevaLinea.material.$touch()"
                                                @blur="$v.nuevaLinea.material.$touch()"
                                            >
                                                <template v-if="loadingMateriales" slot="no-data"><p class="ma-2 ml-4">Buscando...</p></template>
                                                <template v-else-if="buscarMaterial" slot="no-data"><p class="ma-2 ml-4">No se han encontrado coincidencias con el texto introducido.</p></template>
                                                <template v-else slot="no-data"><p class="ma-2 ml-4">Empieza a escribir para buscar.</p></template>
                                                <template v-slot:selection="data">
                                                    <v-chip
                                                        v-bind="data.attrs"
                                                        :input-value="data.selected"
                                                        close
                                                        @click:close="nuevaLinea.material = undefined"
                                                    >
                                                        {{ data.item.CodigoArticulo }} - {{ data.item.DescripcionArticulo }}
                                                    </v-chip>
                                                </template>
                                                <template v-slot:item="data">
                                                    <template>
                                                        <v-list-item-content>
                                                            <v-list-item-title>{{ data.item.CodigoArticulo }} - {{ data.item.DescripcionArticulo }}</v-list-item-title>
                                                        </v-list-item-content>
                                                    </template>
                                                </template>
                                            </v-autocomplete>     
                                        </v-col>
                                    </v-row>
                                    <v-row >
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                                v-model="nuevaLinea.unidades"
                                                label="Unidades..."
                                                prepend-icon="mdi-file-search-outline"
                                                type="number"
                                                clearable
                                                :error-messages="errorUnidades"
                                                @input="$v.nuevaLinea.unidades.$touch()"
                                                @blur="$v.nuevaLinea.unidades.$touch()"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                                v-model="nuevaLinea.precio"
                                                label="Precio..."
                                                prepend-icon="mdi-file-search-outline"
                                                type="number"
                                                clearable
                                                @input="$v.nuevaLinea.precio.$touch()"
                                                @blur="$v.nuevaLinea.precio.$touch()"
                                                :error-messages="errorPrecio"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col>
                                            <v-select
                                                v-model="nuevaLineaExito"
                                                :items="['0', '50', '100']"
                                                prepend-icon="mdi-file-search-outline"
                                                label="% Éxito..."
                                            ></v-select>
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="nuevaLineaExito === '0'">
                                        <v-col>
                                            <v-select
                                                v-model="nuevaLinea.motivoBaja"
                                                :items="['Precio']"
                                                prepend-icon="mdi-file-search-outline"
                                                label="Motivo Baja"
                                                clearable
                                            ></v-select>
                                        </v-col>
                                    </v-row>
                                </span>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn
                                text
                                @click="dialogDatosLinea = false; borrarNuevaLinea();"
                                >
                                Cancelar
                                </v-btn>
                                <v-spacer></v-spacer>
                                <div @mouseover="$v.nuevaLinea.$touch()">
                                    <v-btn
                                        color="green darken-1"
                                        text
                                        @click="añadirLinea(); dialogDatosLinea = false;"
                                        :disabled="$v.nuevaLinea.$invalid"
                                    >
                                        Guardar
                                    </v-btn>
                                </div>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <!-- FIN Dialogo 2 -->

                    <!-- Dialogo 3 -->
                    <!-- Dialogo Salir -->
                    <span>
                        <v-row>
                            <v-col cols="6" md="6">
                                <v-dialog max-width="380"
                                    v-model="dialogSalir"
                                    persistent
                                >
                                    <v-card>
                                        <v-card-title>
                                            ¡Atención!
                                        </v-card-title>
                                        <v-card-text>
                                            Vas a salir sin guardar la oferta. ¿Estás seguro?
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-btn text @click="dialogSalir = false">
                                                Cancelar
                                            </v-btn>
                                            <v-spacer></v-spacer>
                                            <div @mouseover="$v.oferta.proveedor.$touch()">
                                                <v-btn text color="green" @click="ofertaFinalizada = false; guardarTodo(); dialogSalir = false;" :disabled="$v.oferta.$invalid || lineas.lineas.length < 1"> <!-- disabled: los 2 tienen que ser false para que disabled sea false -->
                                                    Guardar
                                                </v-btn>
                                            </div>
                                            <v-btn text color="red" @click="salir()">
                                                Salir
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-col>
                        </v-row>
                    </span>
                    <!-- FIN Dialogo 3 -->
                    <!-- Dialog Valores por defecto -->
                    <span>
                        <v-row>
                            <v-col cols="6" md="6">
                                <v-dialog max-width="380"
                                    v-model="dialogValoresDefecto"
                                    persistent
                                >
                                    <v-card>
                                        <v-card-title>
                                            ¡Atención!
                                        </v-card-title>
                                        <v-card-text>
                                            Esto eliminará la oferta actual. ¿Estás seguro?
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-btn text @click="dialogValoresDefecto = false;">
                                                Cancelar
                                            </v-btn>
                                            <v-spacer></v-spacer>
                                            <v-btn text color="error" @click="dialogValoresDefecto = false; borrarNuevaOferta();">
                                                Eliminar
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-col>
                        </v-row>
                    </span>
                    <!-- FIN Dialog Valores por defecto -->
                </v-row>
            </div>
        </template>
    </span>
</template>

<style>
.shake {
  animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
  transform: translate3d(0, 0, 0);
}
@keyframes shake {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
</style>

<script>
    import axios from 'axios';
    import {mapActions} from 'vuex';
    import { required, helpers } from 'vuelidate/lib/validators';
    axios.defaults.withCredentials = true;
    axios.defaults.baseURL = process.env.VUE_APP_API_URL;
    const regex = helpers.regex("mob", /\d+(\,\d+)?/);
    export default {
        props: ['text'],
        name: 'NuevaOferta',
        data () {
            return {
            animated: false,
            dialog: false,
            fab: false,
            transition: 'slide-y-reverse-transition',
            dialogAñadirLineas: false,
            dialogDatosLinea: false,
            dialogSalir: false,
            dialogValoresDefecto: false,
            notifications: false,
            sound: true,
            widgets: false,
            empresas: [],
            loadingProveedores: false,
            loadingMateriales: false,
            loadingNuevaOferta: false,
            proveedores: [],
            materiales: [],
            idCabecera: '',
            oferta:{
                almacen: '',
                atencion: '',
                empresa: '',
                fechaOferta: this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
                observacion: '',
                pedido: 'No',
                precio: 'No',
                proveedor: '',
                transporte: 'Externo'
            },
            nuevaLinea:{
                material: {},
                unidades: '',
                precio: '',
                motivoBaja: '',
                // exito: ''
            },
            nuevaLineaExito: '100',
            editando: [],
            buscarProveedor: '',
            buscarMaterial: '',
            calendario: {
                fechaLista: {
                    mostrar: false,
                    fecha: this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)), //Fecha DD/MM/YYYY
                    date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10), //Fecha YYYY-MM-DD
                },
                fechaLimite: {
                    mostrar: false,
                    fecha: '',
                    date: ''
                }
            },
            lineas: {
                headers: [
                    { text: <v-icon>mdi-cart</v-icon>, value: 'CodigoArticulo', sortable: false },
                    { text: <v-icon>mdi-weight</v-icon>, value: 'Peso', sortable: false },
                    { text: 'Descripción', value: 'DescripcionArticulo', sortable: false },
                    { text: <v-icon>mdi-currency-eur</v-icon>, value: 'Precio', sortable: false },
                    { text: '% Éxito', value: 'Porcen_Exito_Oferta', sortable: false },
                    { text: 'Motivo baja', value: 'UVE_MotivoBajaOferta', sortable: false },
                    { text: 'Acciones', value: 'acciones', align: 'center', sortable: false},
                ],
                lineas: [],
                editadas: [],
                eliminadas: [],
                nuevas: [],
                loading: null,
                sortBy: 'CodigoArticulo',
            },
            hoy: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            ofertaFinalizada: false,
            bloquearCabecera: false
        }
        },
        validations: {
            oferta: {
                empresa:{ required },
                almacen:{ required },
                proveedor:{ required }
            },
            nuevaLinea: {
                material: { required },
                unidades: { required, regex },
                precio: { required, regex }
            }
        },
        watch: {
            'calendario.fechaLista.date'(val){
                this.calendario.fechaLista.fecha = this.formatDate(this.calendario.fechaLista.date)
            },
            'calendario.fechaLimite.date'(val){
                this.calendario.fechaLimite.fecha = this.formatDate(this.calendario.fechaLimite.date)
            },
            'oferta.empresa'(val){
                // this.oferta.proveedor = '',
                // this.proveedores = [],
                // this.oferta.almacen = this.empresas.filter(item => item.empresa.Empresa === this.oferta.empresa)[0].Descripcion
            }
        },
        mounted(){
            
        },
        methods: {
            ...mapActions(['setLoading', 'setSnackbar']),
            info(texto){
                this.setSnackbar({
                    snackbar: true,
                    tipo: 'info',
                    mensaje: texto
                });
            },
            animacionBoton() {
                if (this.lineas.lineas.length == 0) {
                    this.animated = true
                    setTimeout(() => {
                        this.animated = false
                    }, 1000)
                }
            },
            async guardarTodo(){
                this.setLoading(true);
                if (this.oferta.pedido == 'Si') {
                    this.oferta.pedido = -1
                }else{
                    this.oferta.pedido = 0
                }

                if (this.oferta.precio == 'Si') {
                    this.oferta.precio = -1
                }else{
                    this.oferta.precio = 0
                }

                let datos = {
                    lineas: this.lineas.lineas,
                    oferta: this.oferta,
                    calendario: {fechaLista: this.calendario.fechaLista.date, fechaLimite: this.calendario.fechaLimite.date},
                    nuevas: this.lineas.nuevas,
                    editadas: this.lineas.editadas,
                    eliminadas: this.lineas.eliminadas
                }
                datos.oferta.CodigoEmpresa = this.empresas.filter(item => item.empresa.Empresa === this.oferta.empresa)[0].CodigoEmpresa
                datos.oferta.TipoOferta = this.oferta.almacen; // this.empresas.filter(item => item.Descripcion === this.oferta.almacen)[0].UVE_TipoOferta
                datos.lineas.forEach(linea => {
                    if(linea.UVE_MotivoBajaOferta == "Precio"){
                        linea.UVE_MotivoBajaOferta = 'P'
                    }
                });
                datos.finalizado = this.ofertaFinalizada;
                if (this.idCabecera) { // Oferta existente, la actualizamos
                    await axios.post(`/api/nueva-oferta/actualizar/${this.idCabecera}`, datos).then(response => {
                        if(this.ofertaFinalizada){
                            this.setSnackbar({
                                snackbar: true,
                                tipo: 'success',
                                mensaje: 'Oferta enviada correctamente'
                            });
                        }else{
                            this.setSnackbar({
                                snackbar: true,
                                tipo: 'success',
                                mensaje: 'Oferta guardada correctamente'
                            });
                        }
                        this.dialog = false;
                        this.resetOferta();
                    }).catch(error => { 
                        //console.log(error); 
                        if(this.ofertaFinalizada){
                            this.setSnackbar({
                                snackbar: true,
                                tipo: 'error',
                                mensaje: 'Error. No se ha podido enviar la oferta'
                            });
                        }else{
                            this.setSnackbar({
                                snackbar: true,
                                tipo: 'error',
                                mensaje: 'Error. No se ha podido guardar la oferta'
                            });
                        }
                    }).finally(() => {
                        this.setLoading(false);
                    });
                }else{ // Nueva oferta, la insertamos
                    await axios.post('/api/nueva-oferta', datos).then(response => {
                        if(this.ofertaFinalizada){
                            this.setSnackbar({
                                snackbar: true,
                                tipo: 'success',
                                mensaje: 'Oferta enviada correctamente'
                            });
                        }else{
                            this.setSnackbar({
                                snackbar: true,
                                tipo: 'success',
                                mensaje: 'Oferta guardada correctamente'
                            });
                        }
                        this.dialog = false;
                        this.resetOferta();
                    }).catch(error => { 
                        //console.log(error); 
                        if(this.ofertaFinalizada){
                            this.setSnackbar({
                                snackbar: true,
                                tipo: 'error',
                                mensaje: 'Error. No se ha podido enviar la oferta'
                            });
                        }else{
                            this.setSnackbar({
                                snackbar: true,
                                tipo: 'error',
                                mensaje: 'Error. No se ha podido guardar la oferta'
                            });
                        }
                    }).finally(() => {
                        this.setLoading(false);
                    });
                }
            },

            async buscarProveedores(cargarDatos){
                this.proveedores = [];
                if (this.buscarProveedor){
                    this.loadingProveedores = true;
                    try {
                        let codigoEmpresa = this.empresas.filter(item => item.empresa.Empresa === this.oferta.empresa)[0].CodigoEmpresa;
                        let respuesta = await axios.get(`/api/historico-ofertas/proveedor?proveedor=${this.buscarProveedor}&codEmpresa=${codigoEmpresa}`)
                        this.proveedores = respuesta.data
                        if (cargarDatos) {
                            this.oferta.proveedor = this.proveedores[0]
                        }
                    }catch (error) {
                        this.setSnackbar({
                            snackbar: true,
                            tipo: 'error',
                            mensaje: 'Error. No se han podido obtener los proveedores'
                        });
                    }
                }
                this.loadingProveedores = false;
            },
            async verEmpresasAlmacen(){
                try {
                    let respuesta = await axios.get(`/api/nueva-oferta/empresa-almacen`)
                    this.empresas = respuesta.data
                } catch (error) {
                    // console.log(error);
                }
            },
            async buscarMateriales(cargarDatos, idLinea, index){
                this.materiales = [];
                if (this.buscarMaterial != null && this.buscarMaterial != '') {
                    try {
                        let codigoEmpresa = this.empresas.filter(item => item.empresa.Empresa === this.oferta.empresa)[0].CodigoEmpresa;
                        let respuesta = await axios.get(`/api/historico-ofertas/material?material=${this.buscarMaterial}&codEmpresa=${codigoEmpresa}&codDepartamento=${this.oferta.almacen.CodigoDepartamento}`)
                        this.materiales = respuesta.data
                        if (cargarDatos) {
                            let material = this.lineas.lineas.filter(item => item.idLinea == idLinea)
                            this.oferta.proveedor = this.proveedores[0]
                            this.lineas.lineas[index].DescripcionArticulo = this.materiales[0].DescripcionArticulo
                        }
                    } catch (error) {
                        // console.log(error);
                    }
                }
                this.loadingMateriales = false
            },
            async estadoOferta(){
                this.loadingNuevaOferta = true;
                try {
                    let respuesta = await axios.get('/api/nueva-oferta/ofertas-no-finalizadas')
                    //Oferta ya existente
                    if (respuesta.data.length > 0) {
                        this.bloquearCabecera = true;

                        //ID CABECERA
                        this.idCabecera = respuesta.data[0].idCabecera

                        await this.verEmpresasAlmacen();
                        //OFERTA PARA LA EMPRESA --> CodigoEmpresa
                        this.oferta.empresa = this.empresas.filter(item => item.CodigoEmpresa === respuesta.data[0].CodigoEmpresa)[0].empresa.Empresa;

                        //ALMACEN DESTINO --> UVE_TipoOferta
                        this.oferta.almacen = this.empresas.filter(item => item.UVE_TipoOferta === respuesta.data[0].UVE_TipoOferta && item.CodigoEmpresa === respuesta.data[0].CodigoEmpresa)[0];

                        //FECHA LISTA --> UVE_FechaLista
                        this.calendario.fechaLista.date = respuesta.data[0].UVE_FechaLista;

                        //Proveedor --> CodigoProveedor
                        this.buscarProveedor = respuesta.data[0].CodigoProveedor;
                        
                        await this.buscarProveedores(true);

                        //Precio Abierto --> PrecioAbierto
                        // -1 = SI
                        //  0 = NO
                        if (respuesta.data[0].PrecioAbierto == 0) {
                            this.oferta.precio = 'No'
                        }else{
                            this.oferta.precio = 'Si'
                        }

                        //Fecha limite fijación precios --> FechaLimiteFPrecios
                        this.calendario.fechaLimite.date = respuesta.data[0].FechaLimiteFPrecios

                        //Pedido Directo --> PedidoDirecto
                        // -1 = SI
                        //  0 = NO
                        if (respuesta.data[0].PedidoDirecto == 0) {
                            this.oferta.pedido = 'No'
                        }else{
                            this.oferta.pedido = 'Si'
                        }

                        //Observación Oferta --> ObservacionesOferta
                        this.oferta.observacion = respuesta.data[0].ObservacionesOferta

                        //A la atención de --> Nombre1
                        this.oferta.atencion = respuesta.data[0].Nombre1

                        //Transporte --> ObservacionesProveedor
                        this.oferta.transporte = respuesta.data[0].ObservacionesProveedor

                        
                        respuesta.data[0].linea.forEach(element => {
                            if (element.UVE_MotivoBajaOferta == 'P') {
                                element.UVE_MotivoBajaOferta = 'Precio'
                            }
                            //this.buscarMaterial = element.CodigoArticulo;
                            
                            //this.buscarMateriales(true, element.idLinea, this.lineas.lineas.length);
                            this.lineas.lineas.push(
                                {
                                    CodigoArticulo: element.CodigoArticulo,
                                    DescripcionArticulo: element.material.DescripcionArticulo,
                                    Peso: parseFloat(element.Unidades).toString().replace(".",","),
                                    Porcen_Exito_Oferta: element.Porcen_Exito_Oferta,
                                    Precio: parseFloat(element.PrecioUnitario).toString().replace(".",","),
                                    UVE_MotivoBajaOferta: element.UVE_MotivoBajaOferta,
                                    idLinea: element.idLinea
                                }
                            )
                        });
                        this.info('Se ha cargado una oferta no finalizada')
                    //Nueva oferta
                    }else{
                        this.idCabecera = '';
                        await this.verEmpresasAlmacen();
                        this.oferta.empresa = this.empresas[0].empresa.Empresa;
                        this.oferta.almacen = this.empresas.filter(item => item.empresa.Empresa === this.oferta.empresa)[0];
                    }
                    this.dialog = true;
                } catch (error) {
                    this.resetOferta();
                    this.setSnackbar({
                        snackbar: true,
                        tipo: 'error',
                        mensaje: 'Error. No se ha podido recuperar la oferta pendiente. Contacta con el administrador.'
                    });
                }
                this.loadingNuevaOferta = false;
            },
            cambioProveedor(){
                this.oferta.proveedor = '';
                this.proveedores = [];
                this.oferta.almacen = this.empresas.filter(item => item.empresa.Empresa === this.oferta.empresa)[0]
            },
            borrarNuevaOferta(){
                this.setLoading(true);
                if(this.idCabecera != ''){
                    axios.delete(`/api/nueva-oferta/eliminar/${this.idCabecera}`).then(response => {
                        this.resetOferta();
                        this.idCabecera = '';
                        this.setSnackbar({
                            snackbar: true,
                            tipo: 'success',
                            mensaje: 'La oferta pendiente ha sido eliminada'
                        });
                    }).catch(error => { 
                        //console.log(error); 
                        this.setSnackbar({
                            snackbar: true,
                            tipo: 'error',
                            mensaje: 'Error. No se ha podido eliminar la oferta pendiente'
                        });
                    }).finally(() => {
                        this.setLoading(false);
                    });
                }else{
                    this.resetOferta();
                    this.setLoading(false);
                }
            },
            resetOferta(){
                this.calendario.fechaLista.fecha = this.formatDate(this.hoy)
                this.calendario.fechaLista.date = this.hoy
                this.calendario.fechaLimite.fecha = null
                this.calendario.fechaLimite.date = null
                this.oferta = {
                    empresa: this.empresas[0].empresa.Empresa,
                    almacen: this.empresas.filter(item => item.empresa.Empresa === this.oferta.empresa)[0],
                    atencion: '',
                    fechaOferta: this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
                    observacion: '',
                    pedido: 'No',
                    precio: 'No',
                    proveedor: '',
                    transporte: 'Externo'
                },
                this.lineas.lineas = []
                this.lineas.nuevas = []
                this.lineas.editadas = []
                this.lineas.eliminadas = []
                this.proveedores = []
                this.$v.oferta.$reset()
                this.bloquearCabecera = false;
            },
            redondear(numero, decimales) {
                numero = numero.replace(",",".")
                numero = Number(numero).toFixed(decimales).toString().split(".")
                numero[0] = numero[0].replace(/\B(?=(\d{3})+(?!\d))/g,".");
                return numero.join(",")
            },
            añadirLinea(){
                if (this.nuevaLineaExito != '0') {
                    this.nuevaLinea.motivoBaja = ''
                };
                if (this.editando) {
                    let id = this.editando.__ob__.dep.id;
                    let index = 0;
                    this.lineas.lineas.forEach(linea => {
                        if (linea.__ob__.dep.id == id) { //Encontrar la linea que se esta editando
                            linea = {
                                CodigoArticulo: this.nuevaLinea.material.CodigoArticulo,
                                DescripcionArticulo: this.nuevaLinea.material.DescripcionArticulo,
                                Peso: this.nuevaLinea.unidades,
                                Porcen_Exito_Oferta: this.nuevaLineaExito,
                                Precio: this.nuevaLinea.precio,
                                UVE_MotivoBajaOferta: this.nuevaLinea.motivoBaja,
                                idLinea: linea.idLinea
                            };
                            this.lineas.lineas.splice(index,1,linea);
                            // Guardar edicion de lineas que ya existian
                            if (this.lineas.nuevas.findIndex(item => item.idLinea == linea.idLinea) == -1) {
                                let index = this.lineas.editadas.findIndex(item => item.idLinea == linea.idLinea);
                                if (index != -1) {
                                    this.lineas.editadas.splice(index,1,linea);
                                }else {
                                    this.lineas.editadas.push(linea);
                                }
                            // Guardar edicion de lineas añadidas
                            }else{
                                let index = this.lineas.nuevas.findIndex(item => item.idLinea == linea.idLinea);
                                if (index != -1) {
                                    this.lineas.nuevas.splice(index,1,linea);
                                }else {
                                    this.lineas.nuevas.push(linea);
                                }
                            }
                        }
                        index++;
                    });
                    this.borrarNuevaLinea();
                    this.info('Línea modificada correctamente');
                }else{
                    this.lineas.lineas.push(
                        {
                            CodigoArticulo: this.nuevaLinea.material.CodigoArticulo,
                            DescripcionArticulo: this.nuevaLinea.material.DescripcionArticulo,
                            Peso: this.nuevaLinea.unidades,
                            Porcen_Exito_Oferta: this.nuevaLineaExito,
                            Precio: this.nuevaLinea.precio,
                            UVE_MotivoBajaOferta: this.nuevaLinea.motivoBaja,
                            idLinea: this.lineas.lineas.length
                        }
                    );
                    this.lineas.nuevas.push(this.lineas.lineas[this.lineas.lineas.length-1]);
                    this.borrarNuevaLinea();
                    this.setSnackbar({
                        snackbar: true,
                        tipo: 'success',
                        mensaje: 'Línea añadida correctamente'
                    });
                    // console.log(this.lineas.lineas);
                    if(this.lineas.lineas.length > 0 && !this.bloquearCabecera){
                        this.bloquearCabecera = true;
                    }
                }
            },
            borrarNuevaLinea(){
                this.nuevaLinea = {
                    material: {},
                    unidades: '',
                    precio: '',
                    motivoBaja: ''
                },
                this.nuevaLineaExito = '',
                this.materiales = []
                this.nuevaLineaExito = '100'
            },
            editarLinea(item){
                this.editando = item
                this.materiales = [
                    {
                        CodigoArticulo: item.CodigoArticulo,
                        DescripcionArticulo: item.DescripcionArticulo
                    }
                ]
                this.nuevaLinea.material = {
                    CodigoArticulo: item.CodigoArticulo,
                    DescripcionArticulo: item.DescripcionArticulo
                }
                this.nuevaLinea.unidades = item.Peso
                this.nuevaLineaExito = item.Porcen_Exito_Oferta
                this.nuevaLinea.precio = item.Precio
                this.nuevaLinea.motivoBaja = item.UVE_MotivoBajaOferta
                this.dialogDatosLinea = true;
            },
            borrarLinea(item){
                let idLinea = item.idLinea;
                let index = this.lineas.lineas.findIndex(linea => linea.idLinea == idLinea);
                let indexEditadas = this.lineas.editadas.findIndex(linea => linea.idLinea == idLinea);
                if (indexEditadas == -1) {
                    let indexNuevas = this.lineas.nuevas.findIndex(linea => linea.idLinea == idLinea);
                    if (indexNuevas == -1) {
                        this.lineas.eliminadas.push(this.lineas.lineas[index].idLinea);
                    }else {
                        this.lineas.nuevas.splice(indexNuevas, 1)
                    }
                }else {
                    this.lineas.editadas.splice(indexEditadas, 1)
                }
                this.lineas.lineas.splice(index, 1);
                // this.lineas.lineas.forEach(function (linea, i, o) {
                //     if(JSON.stringify(linea)===JSON.stringify(item)){
                //         o.splice(i, 1)
                //     }
                // });
                this.info('Línea eliminada correctamente');
            },
            salir(){
                this.dialogSalir = false; 
                this.dialog = false;
                this.resetOferta();
            },
            formatDate (date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            },
            debounceSearch(func) {
                clearTimeout(this.debounce);
                this.debounce = setTimeout(() => {
                    func.apply();
                }, 600);
            },
            filterObject(item) {
                return item
            }
        },
        computed: {
            errorEmpresa () {
                if (this.$v.oferta.empresa.$dirty){
                    if (this.$v.oferta.empresa.$invalid){
                        return 'Selecciona una empresa';
                    }
                }
            },
            errorAlmacen () {
                if (this.$v.oferta.almacen.$dirty){
                    if (this.$v.oferta.almacen.$invalid){
                        return 'Selecciona un almacén';
                    }
                }
            },
            errorProveedor () {
                if (this.$v.oferta.proveedor.$dirty){
                    if (this.$v.oferta.proveedor.$invalid){
                        return 'Selecciona un proveedor';
                    }
                }
            },
            errorMaterial(){
                if (this.$v.nuevaLinea.material.$dirty){
                    if (this.$v.nuevaLinea.material.$invalid){
                        return 'Elige un material';
                    }
                }
            },
            errorUnidades () {
                if (this.$v.nuevaLinea.unidades.$dirty){
                    if (this.$v.nuevaLinea.unidades.$invalid){
                        return 'Indica la cantidad de unidades';
                    }
                }
            },
            errorPrecio () {
                if (this.$v.nuevaLinea.precio.$dirty){
                    if (this.$v.nuevaLinea.precio.$invalid){
                        return 'Indica el precio';
                    }
                }
            }
        }
    }
</script>